import { create } from "zustand";
import { Mode } from "@cloudscape-design/global-styles";

interface CustomBrandingAssetStore {
    wallpaperPath: string;
    brandLogoPath: string;
    hasTermsOfService: boolean;
    // TODO [LOWA-30534] This is only for old flow
    isResourceReady: boolean;
    customFontBasedCloudscapeTheme: Mode | undefined;
    setWallPaperPath: (path: string) => void;
    setBrandLogoPath: (path: string) => void;
    setHasTermsOfService: (value: boolean) => void;
    // TODO [LOWA-30534] This is only for old flow
    setIsResourceReady: (value: boolean) => void;
    setCustomFontBasedCloudscapeTheme: (theme: Mode | undefined) => void;
}

export const useCustomBrandingAssetStore = create<CustomBrandingAssetStore>(
    (set) => ({
        wallpaperPath: "",
        brandLogoPath: "",
        termsOfService: undefined,
        hasTermsOfService: false,
        // TODO [LOWA-30534] This is only for old flow
        isResourceReady: false,
        customFontBasedCloudscapeTheme: undefined,
        setWallPaperPath: (path) => {
            set(() => ({
                wallpaperPath: path,
            }));
        },
        setBrandLogoPath: (path) => {
            set(() => ({
                brandLogoPath: path,
            }));
        },
        setHasTermsOfService: (value) => {
            set(() => ({
                hasTermsOfService: value,
            }));
        },
        // TODO [LOWA-30534] This is only for old flow
        setIsResourceReady: (value) => {
            set(() => ({
                isResourceReady: value,
            }));
        },
        setCustomFontBasedCloudscapeTheme: (theme) => {
            set(() => ({
                customFontBasedCloudscapeTheme: theme,
            }));
        },
    })
);
